var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons_Delete",
    "data-name": "Icons/Delete",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M9.5,10.762,1.263,19,0,17.737,8.237,9.5,0,1.262,1.263,0,9.5,8.237,17.737,0,19,1.263,10.763,9.5,19,17.737,17.737,19Z",
    fill: "#13112b"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Icons_Delete_background",
    "data-name": "Icons/Delete background",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Color_Liberty_Blue",
    "data-name": "Color/Liberty Blue",
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask-2",
    "data-name": "Mask",
    d: "M9.5,10.762,1.263,19,0,17.737,8.237,9.5,0,1.262,1.263,0,9.5,8.237,17.737,0,19,1.263,10.763,9.5,19,17.737,17.737,19Z",
    fill: "#13112b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color_Liberty_Blue-2",
    "data-name": "Color/Liberty Blue",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color_Liberty_Blue-3",
    "data-name": "Color/Liberty Blue",
    transform: "translate(-40 -39)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 100,
    height: 100,
    fill: "#1a1446"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.033970d4674c9112de6238e712944464.svg";
export { ForwardRef as ReactComponent };